import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a7e53b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "padding-left-60" }
const _hoisted_2 = { class: "p-d-flex p-justify-between" }
const _hoisted_3 = { class: "search-block" }
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "p-d-flex p-align-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-text-uppercase" }, "add the creator to the agency", -1))
const _hoisted_10 = { class: "p-d-flex p-jc-end p-mt-4" }
const _hoisted_11 = { class: "p-d-flex p-justify-between" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Your Profile", -1))
const _hoisted_13 = { class: "p-d-flex p-mt-6 p-grid p-col-12" }
const _hoisted_14 = { class: "p-col-10 p-lg-12 p-mt-6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "About", -1))
const _hoisted_16 = { class: "text-pre-line" }
const _hoisted_17 = { class: "p-col-12 p-mt-6" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Content", -1))
const _hoisted_19 = { class: "text-pre-line p-d-flex p-flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_payment_information_modal = _resolveComponent("payment-information-modal")!
  const _component_invite_to_campaign = _resolveComponent("invite-to-campaign")!
  const _component_influencer_information = _resolveComponent("influencer-information")!
  const _component_Channels = _resolveComponent("Channels")!
  const _component_influencer_edit = _resolveComponent("influencer-edit")!
  const _component_latest_content_item = _resolveComponent("latest-content-item")!
  const _component_empty_list = _resolveComponent("empty-list")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, { loading: _ctx.loading }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Dialog, {
          header: "add the creator to the agency",
          visible: _ctx.showModalAddCreator,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModalAddCreator) = $event)),
          class: "login-card p-col-12 p-md-6 p-xl-4 gi-dialog",
          modal: true
        }, {
          header: _withCtx(() => [
            _hoisted_9
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Button, {
                label: "Close",
                class: "p-button-link",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModalAddCreator = false))
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _createTextVNode("Select the channel you'd like to invite "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.creator?.name), 1),
              _createTextVNode(" to:")
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_InputText, {
                    class: "input-search",
                    onKeydown: _withKeys(_ctx.addCreator, ["enter"]),
                    type: "text",
                    modelValue: _ctx.forUsername,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.forUsername) = $event)),
                    placeholder: "Channel name"
                  }, null, 8, ["onKeydown", "modelValue"])
                ])
              ]),
              _createVNode(_component_Button, {
                label: "Search",
                class: "gi-button",
                loading: _ctx.searchChannelLoading,
                onClick: _ctx.addCreator,
                icon: "pi pi-check"
              }, null, 8, ["loading", "onClick"])
            ]),
            (_ctx.searchResult?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResult, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `channel_${index}`,
                      class: "channel-item"
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          src: item?.snippet?.thumbnails?.default?.url,
                          style: {"width":"35px","border-radius":"50%"},
                          class: "p-mr-2"
                        }, null, 8, _hoisted_8),
                        _createTextVNode(" " + _toDisplayString(item?.snippet?.channelTitle), 1)
                      ]),
                      _createVNode(_component_Button, {
                        label: _ctx.isChannelAlredyAdded(_ctx.channels?.channel?.items, item?.id?.channelId) ? 'Delete channel' : 'Add channel',
                        class: "gi-button",
                        loading: _ctx.searchChannelLoading,
                        onClick: ($event: any) => (_ctx.isChannelAlredyAdded(_ctx.channels?.channel?.items, item?.id?.channelId)
                 ? _ctx.deleteChanel(item?.id?.channelId, index) : _ctx.selectChannelForAdd(item)),
                        icon: _ctx.isChannelAlredyAdded(_ctx.channels?.channel?.items, item?.id?.channelId) ? 'pi pi-times' : 'pi pi-check'
                      }, null, 8, ["label", "loading", "onClick", "icon"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["visible"]),
        (_ctx.changePaymentInfo)
          ? (_openBlock(), _createBlock(_component_payment_information_modal, {
              key: 0,
              "show-modal": _ctx.changePaymentInfo,
              user: _ctx.user,
              "is-creator": _ctx.user.isCreator() || _ctx.user.isAgencyOwner(),
              onPaymentInfoChange: _ctx.paymentInfoChange,
              onChangeInfoLegal: _ctx.paymentInfoChange,
              onChangeInfo: _ctx.paymentInfoChange,
              onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePaymentInfo = false))
            }, null, 8, ["show-modal", "user", "is-creator", "onPaymentInfoChange", "onChangeInfoLegal", "onChangeInfo"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", null, [
            (_ctx.user.isCreator() || _ctx.user.isAgencyOwner())
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Edit payment info",
                  class: "p-button-link edit-button p-mt-6 p-ml-auto",
                  icon: "pi pi-credit-card",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changePaymentInfo = true))
                }))
              : _createCommentVNode("", true),
            (_ctx.user.isCreator() || _ctx.user.isAgencyOwner())
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  label: "Edit Profile",
                  class: "p-button-link edit-button p-mt-6 p-ml-auto",
                  icon: "pi pi-pencil",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showEditModal = true))
                }))
              : _createCommentVNode("", true),
            (_ctx.user.isCreator() || _ctx.user.isAgencyOwner())
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  label: _ctx.user.isCreator() ? 'Switch to agency' : 'Switch to creator',
                  class: "p-button-link edit-button p-mt-6 p-ml-auto",
                  icon: "pi pi-replay",
                  onClick: _ctx.switchAccount
                }, null, 8, ["label", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.user.isAgencyOwner())
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 3,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showModalAddCreator = true)),
                  label: "add creator",
                  class: "p-button-link edit-button p-mt-6 p-ml-auto",
                  icon: "pi pi-user-plus"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_invite_to_campaign, {
              "show-modal": _ctx.showInviteModal,
              "onUpdate:showModal": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showInviteModal) = $event)),
              "creator-id": _ctx.creatorId,
              creator: _ctx.creator
            }, null, 8, ["show-modal", "creator-id", "creator"]),
            (_ctx.user.isBrandOwner())
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 4,
                  label: "Invite to Campaign",
                  class: "invitation",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showInviteModal = true))
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_influencer_information, {
            class: "p-col-9",
            creator: _ctx.creator
          }, null, 8, ["creator"]),
          _createVNode(_component_Channels, {
            onSuccessAddChannel: _ctx.successAddChannel,
            channelsYT: _ctx.channels?.channel?.items,
            class: "p-ml-6",
            user: _ctx.creator
          }, null, 8, ["onSuccessAddChannel", "channelsYT", "user"]),
          (_ctx.user)
            ? (_openBlock(), _createBlock(_component_influencer_edit, {
                key: 0,
                show: _ctx.showEditModal,
                "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showEditModal) = $event)),
                "is-agency": _ctx.user.isAgencyOwner(),
                creator: _ctx.creator,
                onSave: _ctx.updateCreator,
                photo: _ctx.user.isAgencyOwner() ? _ctx.creator?.agencyData?.photo : _ctx.creator?.profile?.photo
              }, null, 8, ["show", "is-agency", "creator", "onSave", "photo"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.creator?.profile?.description || _ctx.creator?.agencyData?.description), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("h5", null, _toDisplayString(_ctx.latestContent?.totalResults) + " results", 1),
          _createElementVNode("p", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.latestContent?.contentItems, (item, index) => {
              return (_openBlock(), _createBlock(_component_latest_content_item, {
                item: item,
                favorites: false,
                onClick: ($event: any) => (_ctx.$router.push({ name: 'content-item', params: { itemID: item?.id }})),
                key: `${index}_content`
              }, null, 8, ["item", "onClick"]))
            }), 128)),
            (!_ctx.latestContent?.contentItems.length)
              ? (_openBlock(), _createBlock(_component_empty_list, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}